export default "__VITE_PUBLIC_ASSET__13d0be42__"